<h2 class="mt-4">{{cardConfiguration.title}}</h2>

<fieldset *ngIf="isVersion2()" [disabled]="isWorkflowOnSubscriber">

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label class="disabled" for="SubscriberNumber">{{'CardCgaPensionStatus.SubscriberNumber' | translate}}</label>
        <input class="form-control" type="text" numeric="7" maxlength="7" [(ngModel)]="cardData.subscriberNumber" #subscriberNumber="ngModel" name="subscriberNumber"
               [readonly]="true" readonly>
        <validation-message [control]="subscriberNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SubscriberType"><span class="mandatory">*</span>{{'CardCgaPensionStatus.SubscriberType' | translate}}</label>
        <div class="btn-group btn-group-toggle w-100">
          <label *ngFor="let domain of subscriberTypes;" tabindex="0" class="btn btn-toogle" [class.active]="domain.code==cardData.subscriberTypeCode" [radioLabel]="subscriberTypeCode">
            <input type="radio" [(ngModel)]="cardData.subscriberTypeCode" #subscriberTypeCode="ngModel" name="subscriberTypeCode" [value]="domain.code" required
                   (ngModelChange)="subscriberTypeCodeChanged()"
                   [clearRelated]="(cardData.subscriberTypeCode?.toString() != '02')? {model : this.cardData , propsToReset : ['professionalCategoryCode','retirementLimitAgeCode','retirementLimitDate']} : {model : this.cardData , propsToReset : ['professionalCategoryCode','retirementLimitAgeCode']}">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>

      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group" [ngClass]="cardData.subscriberTypeCode!='02' ? 'disabled' : '' ">
        <label><span class="mandatory" *ngIf="cardData.subscriberTypeCode == '02'">*</span>{{'CardCgaPensionStatus.MecanograficNumber' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardCgaPensionStatus.MecanograficNumber' | translate}}"
               [(ngModel)]="cardData.mecanograficNumber" name="mecanograficNumber" #mecanograficNumber="ngModel" maxlength="10" [required]="cardData.subscriberTypeCode=='02'" [disabled]="cardData.subscriberTypeCode!='02'">
        <validation-message [control]="mecanograficNumber"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="RetirementTaxStartDate">
          <span class="mandatory">*</span>{{'CardCgaPensionStatus.RetirementTaxStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementTaxStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
            <input #dpRetirementTaxStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                   [minDate]="dateOfBirthPlus12()" [maxDate]="currentDate"
                   [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false}"
                   [(ngModel)]="cardData.retirementTaxStartDate" name="retirementTaxStartDate" #retirementTaxStartDate="ngModel"
                   required
                   placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                   [clearRelated]="{model : this.cardData , propsToReset : ['quotaValueCode','paymentStartDate','compensationPre73']} "
                   (ngModelChange)="retirementOnChange()" maxlength="10"
                   (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpRetirementTaxStartDate)" />
            <div class="input-group-append disable-on-fieldset" (click)="!dpRetirementTaxStartDate.isDisabled && dpRetirementTaxStartDate.toggle()">
              <span class="input-group-text" id="basic-addon2">
                <i class="icon-calendar"></i>
              </span>
            </div>
            <validation-message [control]="retirementTaxStartDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label [class.disabled]="!requestedByCGD">
          <span *ngIf="parentWorkflow.workflowInstance.formData['StepServiceInfo']['ServiceIdentification']['code'] === '2251'" class="mandatory">*</span>
          Data de admissão na CGD
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique a data de admissão na CGD que terá que ser posterior à data de nascimento +12 anos e inferior à data actual."></span>
        </label>
        <div class="input-group">
          <input #dpCGDRegisterDate="bsDatepicker" bsDatepicker
                 type="text"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.cgdRegisterDate" name="cgdRegisterDate" #cgdRegisterDate="ngModel"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="currentDate"
                 [required]="parentWorkflow.workflowInstance.formData['StepServiceInfo']['ServiceIdentification']['code'] === '2251'"
                 [disabled]="!requestedByCGD"
                 maxlength="10"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpCGDRegisterDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpCGDRegisterDate.isDisabled && dpCGDRegisterDate.toggle()">
            <span class="input-group-text">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="cgdRegisterDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="!isExSubscritor">
      <div class="form-group">
        <label [class.disabled]="cardData.professionalCategoryCode?.toString() !== '5'">
          <span *ngIf="cardData.professionalCategoryCode?.toString() === '5'" class="mandatory">*</span>
          Data de admissão no CEJ
        </label>
        <div class="input-group">
          <input #dpCEJRegisterDate="bsDatepicker" bsDatepicker
                 type="text"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [(ngModel)]="cardData.cejRegisterDate" name="cejRegisterDate" #cejRegisterDate="ngModel"
                 [minDate]="dateOfBirthPlus18"
                 [maxDate]="currentDate"
                 [required]="cardData.professionalCategoryCode?.toString() === '5'"
                 [disabled]="cardData.professionalCategoryCode?.toString() !== '5'"
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpCEJRegisterDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpCEJRegisterDate.isDisabled && dpCEJRegisterDate.toggle()">
            <span class="input-group-text">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="cejRegisterDate"></validation-message>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="LegalRetirementReason">
          <span class="mandatory">*</span>
          {{'CardCgaPensionStatus.LegalRetirementReason' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.legalRetirementReason" name="legalRetirementReason"
                #legalRetirementReason="ngModel"
                [dropdownTitle]="{value : cardData.legalRetirementReason }"
                [clearRelated]="{model : this.cardData , propsToReset : ['otherLegalReason']} "
                required nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getlegalRetirementReasons()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="legalRetirementReason"></validation-message>
      </div>
    </div>
    <div *ngIf="cardData.legalRetirementReason?.toString() === '10'" class="col-sm-8">
      <div class="form-group">
        <label for="OtherLegalReason">
          <span *ngIf="cardData.legalRetirementReason === '10'" class="mandatory">*</span>
          Outra base legal AP
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Indique qual a legislação que permitiu a inscrição do subscritor na aposentação na data indicada"></span>
        </label>
        <input class="form-control" id="otherLegalReason" placeholder="Indique qual a outra legislação" type="text"
               [(ngModel)]="cardData.otherLegalReason"
               #otherLegalReason="ngModel"
               [required]="cardData.legalRetirementReason === '10'"
               [disabled]="cardData.legalRetirementReason !== '10'"
               name="otherLegalReason" rows="1" cols="60" maxlength="60">
        <validation-message [control]="otherLegalReason"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SurvivalTaxStartDate">
          <span class="mandatory" *ngIf="cardData.retirementTaxStartDate">*</span>{{'CardCgaPensionStatus.SurvivalTaxStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.SurvivalTaxStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpSurvivalTaxStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.survivalTaxStartDate" name="survivalTaxStartDate" #survivalTaxStartDate="ngModel"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73"
                 [minDate]="getMinSurvivalDate()"
                 [maxDate]="getMaxSurvivalDate()"
                 maxlength="10"
                 required
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpSurvivalTaxStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpSurvivalTaxStartDate.isDisabled && dpSurvivalTaxStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="survivalTaxStartDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="LegalSurvivalReason">
          <span class="mandatory">*</span>
          {{'CardCgaPensionStatus.LegalSurvivalReason' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.LegalSurvivalReason' | translate}}"></span>
        </label>
        <select class="custom-select" [(ngModel)]="cardData.legalSurvivalReason" name="legalSurvivalReason"
                #legalSurvivalReason="ngModel"
                [dropdownTitle]="{value : cardData.legalSurvivalReason }" nullableSelect required>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getlegalSurvivalReasons()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="legalSurvivalReason"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="CompensationPre73" [class.disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73">
          <span class="mandatory" *ngIf="cardData.retirementTaxStartDate &&  cardData.retirementTaxStartDate < date73">*</span>
          {{'CardCgaPensionStatus.CompensationPre73' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.CompensationPre73' | translate}}"></span>
        </label>

        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.CurrencyCompensationPre73' | translate}}"
                 [required]="cardData.retirementTaxStartDate &&  cardData.retirementTaxStartDate < date73"
                 [disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73"
                 [(ngModel)]="cardData.compensationPre73" name="compensationPre73" #compensationPre73="ngModel" maxValue="999999,99" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="compensationPre73"></validation-message>
        </div>

      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label [ngClass]="dpPaymentStartDate.isDisabled ? 'disabled' : '' " for="PaymentStartDate">
          {{'CardCgaPensionStatus.PaymentStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.PaymentStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpPaymentStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="date73" [(ngModel)]="cardData.paymentStartDate"
                 [disabled]="!cardData.retirementTaxStartDate || ((cardData.preRetirementTaxStartDate && equalUTCDayDate(cardData.preRetirementTaxStartDate, cardData.retirementTaxStartDate) && cardData.retirementTaxStartDate < date73) || (cardData.retirementTaxStartDate >= date73)) || !cardData.compensationPre73"
                 name="paymentStartDate" #paymentStartDate="ngModel" externalValidation
                 [clearRelated]="{model : this.cardData , propsToReset : ['quotaValueCode','retirementTaxEarnings']} " clearOnlyOnReset
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpPaymentStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpPaymentStartDate.isDisabled && dpPaymentStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="paymentStartDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label [ngClass]="!cardData.paymentStartDate ? 'disabled' : ''"><span class="mandatory" *ngIf="cardData.paymentStartDate">*</span>{{'CardCgaPensionStatus.QuotaValue' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.quotaValueCode"
                [dropdownTitle]="{value : cardData.quotaValueCode,dimensions : quotaValues}"
                name="quotaValueCode" #quotaValueCode="ngModel" [required]="cardData.paymentStartDate" [disabled]="!cardData.paymentStartDate" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of quotaValues" [value]="domain.description">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="quotaValueCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="retirementTaxEarnings" [class.disabled]="!cardData.paymentStartDate">
          <span *ngIf="cardData.paymentStartDate" class="mandatory">*</span>
          Remuneração DL 24.046 (em euros)
        </label>

        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.retirementTaxEarnings" name="retirementTaxEarnings" #retirementTaxEarnings="ngModel" messageFieldType="currency"
                 [disabled]="!cardData.paymentStartDate"
                 [required]="cardData.paymentStartDate">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="retirementTaxEarnings"></validation-message>
        </div>

      </div>
    </div>

  </div>

  <div class="row">
    <!--<div *ngIf="this.parentWorkflow.workflowVersion.toString() === '1' || this.parentWorkflow.workflowVersion === undefined" class="col-sm-8">
      <div class="form-group">
        <label for="ProfessionalCategory" [class.disabled]="!this.cardData.subscriberTypeCode">
          <span class="mandatory" *ngIf="this.cardData.subscriberTypeCode">*</span>{{'CardCgaPensionStatus.ProfessionalCategory' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.professionalCategoryCode" name="professionalCategoryCode"
                #professionalCategoryCode="ngModel" required (ngModelChange)="professionCategoryChanged()"
                [disabled]="!this.cardData.subscriberTypeCode"
                [dropdownTitle]="{value : cardData.professionalCategoryCode, dimensions : professionalCategories }"
                [clearRelated]="(cardData.professionalCategoryCode?.toString() != '5')? {model : this.cardData , propsToReset : ['cejRegisterDate']} : null"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getFilteredProfessionalCategories()" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="professionalCategoryCode"></validation-message>
      </div>
    </div>-->

    <div *ngIf="this.parentWorkflow.workflowVersion.toString() === '2'" class="col-sm-8">
      <div class="form-group">
        <label for="ProfessionalCategory" [class.disabled]="!this.cardData.subscriberTypeCode">
          <span class="mandatory" *ngIf="this.cardData.subscriberTypeCode">*</span>{{'CardCgaPensionStatus.ProfessionalCategory' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.professionalCategoryCode" name="professionalCategoryCode"
                #professionalCategoryCode="ngModel" required (ngModelChange)="professionCategoryChanged()"
                [disabled]="!this.cardData.subscriberTypeCode"
                [dropdownTitle]="{value : cardData.professionalCategoryCode, dimensions : professionalCategories }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getFilteredProfessionalCategories()" [value]="domain.value">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="professionalCategoryCode"></validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignment"><span class="mandatory">*</span>{{'CardCgaPensionStatus.WorkAssignment' | translate}}</label>
        <input class="form-control" type="text" [(ngModel)]="cardData.workAssignment" name="workAssignment"
               placeholder="{{'Placeholders.CardCgaPensionStatus.WorkAssignment' | translate}}"
               #workAssignment="ngModel" required maxlength="60">
        <validation-message [control]="workAssignment"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignmentCode"><span class="mandatory">*</span>{{'CardCgaPensionStatus.WorkAssignmentCode' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.workAssignmentCode" name="workAssignmentCode"
                #workAssignmentCode="ngModel" required
                [dropdownTitle]="{value : cardData.workAssignmentCode, dimensions : workAssignmentCodes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of workAssignmentCodes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="workAssignmentCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignmentStartDate">
          <span class="mandatory">*</span>
          {{'CardCgaPensionStatus.WorkAssignmentStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.WorkAssignmentStartDate' | translate}}"></span>
        </label>
        <div class="input-group">
          <input #dpWorkAssignmentStartDate="bsDatepicker" bsDatepicker
                 type="text"
                 autocomplete="off"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false}"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="currentDate"
                 [(ngModel)]="cardData.workAssignmentStartDate" name="workAssignmentStartDate" #workAssignmentStartDate="ngModel"
                 required
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpWorkAssignmentStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpWorkAssignmentStartDate.isDisabled && dpWorkAssignmentStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="workAssignmentStartDate"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row"  *ngIf="isExSubscritor">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="dataCessacao">
          <span class="mandatory">*</span>
          Data de cessação de funções
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Data em que deixou de exercer funções na função pública."></span>
        </label>

        <div class="input-group">
          <input #dpDataCessacao="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }" required
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [(ngModel)]="cardData.dataCessacao" name="dataCessacao" #dataCessacao="ngModel"
                 [minDate]="getRetirementTaxStartDate()"
                 [maxDate]="currentDate"
                 maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDataCessacao)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpDataCessacao.isDisabled && dpDataCessacao.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="dataCessacao"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4" *ngIf="isWorkflowAgeLimit">
      <div class="form-group">
        <label for="RetirementLimitAge" class="disabled">
          {{'CardCgaPensionStatus.RetirementLimitAge' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementLimitAge' | translate}}"></span>
        </label>
        <select class="custom-select" [(ngModel)]="cardData.retirementLimitAgeCode" name="retirementLimitAgeCode"
                #retirementLimitAgeCode="ngModel"
                [dropdownTitle]="{value : cardData.retirementLimitAgeCode, dimensions : limitAgesByProfCategory}" disabled nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getAgeLimits()" [value]="domain.value">
            {{domain.filter}}
          </option>
        </select>
        <validation-message [control]="retirementLimitAgeCode"></validation-message>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="isWorkflowAgeLimit">
      <div class="form-group">
        <label for="RetirementLimitDate" class="disabled">
          {{'CardCgaPensionStatus.RetirementLimitDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementLimitDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpRetirementLimitDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 maxlength="10"
                 [(ngModel)]="cardData.retirementLimitDate" name="retirementLimitDate" #retirementLimitDate="ngModel" disabled
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" >
          <div class="input-group-append disable-on-fieldset" (click)="!dpRetirementLimitDate.isDisabled && dpRetirementLimitDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="retirementLimitDate"></validation-message>
        </div>
      </div>
    </div>
  </div>
</fieldset>

<!--
****************************************
  V1

-->

<fieldset *ngIf="!isVersion2()" [disabled]="isWorkflowOnSubscriber">

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label class="disabled" for="SubscriberNumber">{{'CardCgaPensionStatus.SubscriberNumber' | translate}}</label>
        <input class="form-control" type="text" numeric="7" maxlength="7" [(ngModel)]="cardData.subscriberNumber" #subscriberNumber="ngModel" name="subscriberNumber"
               [readonly]="true" readonly>
        <validation-message [control]="subscriberNumber"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SubscriberType"><span class="mandatory">*</span>{{'CardCgaPensionStatus.SubscriberType' | translate}}</label>
        <div class="btn-group btn-group-toggle w-100">
          <label *ngFor="let domain of subscriberTypes;" tabindex="0" class="btn btn-toogle" [class.active]="domain.code==cardData.subscriberTypeCode" [radioLabel]="subscriberTypeCode">
            <input type="radio" [(ngModel)]="cardData.subscriberTypeCode" #subscriberTypeCode="ngModel" name="subscriberTypeCode" [value]="domain.code" required
                   [clearRelated]="{model : this.cardData , propsToReset : ['professionalCategoryCode','retirementLimitAgeCode','retirementLimitDate']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>

      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group" [ngClass]="cardData.subscriberTypeCode!='02' ? 'disabled' : '' ">
        <label><span class="mandatory" *ngIf="cardData.subscriberTypeCode == '02'">*</span>{{'CardCgaPensionStatus.MecanograficNumber' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardCgaPensionStatus.MecanograficNumber' | translate}}"
               [(ngModel)]="cardData.mecanograficNumber" name="mecanograficNumber" #mecanograficNumber="ngModel" maxlength="10" [required]="cardData.subscriberTypeCode=='02'" [disabled]="cardData.subscriberTypeCode!='02'">
        <validation-message [control]="mecanograficNumber"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="RetirementTaxStartDate">
          <span class="mandatory">*</span>{{'CardCgaPensionStatus.RetirementTaxStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementTaxStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpRetirementTaxStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [minDate]="dateOfBirthPlus12()" [maxDate]="currentDate"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.retirementTaxStartDate" name="retirementTaxStartDate" #retirementTaxStartDate="ngModel"
                 required
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [clearRelated]="{model : this.cardData , propsToReset : ['quotaValueCode','paymentStartDate','compensationPre73']} "
                 (ngModelChange)="retirementOnChange()"
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpRetirementTaxStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpRetirementTaxStartDate.isDisabled && dpRetirementTaxStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="retirementTaxStartDate"></validation-message>
        </div>
      </div>
    </div>

    <div class="col-sm-8">
      <div class="form-group">
        <label for="LegalRetirementReason">
          {{'CardCgaPensionStatus.LegalRetirementReason' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.LegalRetirementReason' | translate}}"></span>
        </label>

        <input class="form-control" type="text" [(ngModel)]="cardData.legalRetirementReason" name="legalRetirementReason" maxlength="60"
               placeholder="{{'Placeholders.CardCgaPensionStatus.LegalRetirementReason' | translate}}"
               #legalRetirementReason="ngModel">
        <validation-message [control]="legalRetirementReason"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="SurvivalTaxStartDate" [class.disabled]="!cardData.retirementTaxStartDate">
          <span class="mandatory" *ngIf="cardData.retirementTaxStartDate">*</span>{{'CardCgaPensionStatus.SurvivalTaxStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.SurvivalTaxStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpSurvivalTaxStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.survivalTaxStartDate" name="survivalTaxStartDate" #survivalTaxStartDate="ngModel"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="getSurvivalDate()" [maxDate]="getSurvivalDate()" maxlength="10"
                 required
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpSurvivalTaxStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpSurvivalTaxStartDate.isDisabled && dpSurvivalTaxStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="survivalTaxStartDate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="form-group">
        <label for="LegalSurvivalReason">
          {{'CardCgaPensionStatus.LegalSurvivalReason' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.LegalSurvivalReason' | translate}}"></span>
        </label>

        <input class="form-control" type="text" [(ngModel)]="cardData.legalSurvivalReason" name="legalSurvivalReason" maxlength="60"
               placeholder="{{'Placeholders.CardCgaPensionStatus.LegalSurvivalReason' | translate}}"
               #legalSurvivalReason="ngModel">
        <validation-message [control]="legalSurvivalReason"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="CompensationPre73" [class.disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73">
          <span class="mandatory" *ngIf="cardData.retirementTaxStartDate &&  cardData.retirementTaxStartDate < date73">*</span>
          {{'CardCgaPensionStatus.CompensationPre73' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.CompensationPre73' | translate}}"></span>
        </label>

        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [required]="cardData.retirementTaxStartDate &&  cardData.retirementTaxStartDate < date73"
                 [disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73"
                 [(ngModel)]="cardData.compensationPre73" name="compensationPre73" #compensationPre73="ngModel" maxValue="999000" messageFieldType="currency">
          <span class="input-icon-span-left">€</span>
          <validation-message [control]="compensationPre73"></validation-message>
        </div>

      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [ngClass]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73 ? 'disabled' : '' " for="PaymentStartDate">
          <!-- span class="mandatory" *ngIf="cardData.retirementTaxStartDate && cardData.retirementTaxStartDate < date73">*</!--span> -->
          {{'CardCgaPensionStatus.PaymentStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.PaymentStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpPaymentStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="getDatePlusDays(date73,-1)" [(ngModel)]="cardData.paymentStartDate"
                 [disabled]="!cardData.retirementTaxStartDate || cardData.retirementTaxStartDate >= date73"
                 name="paymentStartDate" #paymentStartDate="ngModel" externalValidation maxlength="10"
                 [clearRelated]="{model : this.cardData , propsToReset : ['quotaValueCode']} " clearOnlyOnReset
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpPaymentStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpPaymentStartDate.isDisabled && dpPaymentStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="paymentStartDate"></validation-message>
        </div>
      </div>
    </div>


    <div class="col-sm-4">
      <div class="form-group">
        <label [ngClass]="!cardData.paymentStartDate ? 'disabled' : ''"><span class="mandatory" *ngIf="cardData.paymentStartDate">*</span>{{'CardCgaPensionStatus.QuotaValue' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.quotaValueCode"
                [dropdownTitle]="{value : cardData.quotaValueCode,dimensions : quotaValues}"
                name="quotaValueCode" #quotaValueCode="ngModel" [required]="cardData.paymentStartDate" [disabled]="!cardData.paymentStartDate" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of quotaValues" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="quotaValueCode"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">


    <div class="col-sm-8">
      <div class="form-group">
        <label for="ProfessionalCategory" [class.disabled]="!this.cardData.subscriberTypeCode">
          <span class="mandatory" *ngIf="this.cardData.subscriberTypeCode">*</span>{{'CardCgaPensionStatus.ProfessionalCategory' | translate}}
        </label>
        <select class="custom-select" [(ngModel)]="cardData.professionalCategoryCode" name="professionalCategoryCode"
                #professionalCategoryCode="ngModel" required (ngModelChange)="professionCategoryChanged()"
                [disabled]="!this.cardData.subscriberTypeCode"
                [dropdownTitle]="{value : cardData.professionalCategoryCode, dimensions : professionalCategories }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of getFilteredProfessionalCategories()" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="professionalCategoryCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignment"><span class="mandatory">*</span>{{'CardCgaPensionStatus.WorkAssignment' | translate}}</label>
        <input class="form-control" type="text" [(ngModel)]="cardData.workAssignment" name="workAssignment"
               placeholder="{{'Placeholders.CardCgaPensionStatus.WorkAssignment' | translate}}"
               #workAssignment="ngModel" required maxlength="60">
        <validation-message [control]="workAssignment"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignmentCode"><span class="mandatory">*</span>{{'CardCgaPensionStatus.WorkAssignmentCode' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.workAssignmentCode" name="workAssignmentCode"
                #workAssignmentCode="ngModel" required
                [dropdownTitle]="{value : cardData.workAssignmentCode, dimensions : workAssignmentCodes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of workAssignmentCodes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="workAssignmentCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="WorkAssignmentStartDate">
          <span class="mandatory">*</span>{{'CardCgaPensionStatus.WorkAssignmentStartDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.WorkAssignmentStartDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpWorkAssignmentStartDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [minDate]="dateOfBirthPlus12()"
                 [maxDate]="currentDate"
                 [(ngModel)]="cardData.workAssignmentStartDate" name="workAssignmentStartDate" #workAssignmentStartDate="ngModel"
                 required
                 maxlength="10"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpWorkAssignmentStartDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpWorkAssignmentStartDate.isDisabled && dpWorkAssignmentStartDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="workAssignmentStartDate"></validation-message>
        </div>
      </div>
    </div>
    <div class="col-sm-4" *ngIf="isWorkflowAgeLimit">
      <div class="form-group">
        <label for="RetirementLimitAge" class="disabled">
          {{'CardCgaPensionStatus.RetirementLimitAge' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementLimitAge' | translate}}"></span>
        </label>
        <select class="custom-select" [(ngModel)]="cardData.retirementLimitAgeCode" name="retirementLimitAgeCode"
                #retirementLimitAgeCode="ngModel"
                [dropdownTitle]="{value : cardData.retirementLimitAgeCode, dimensions : limitAgesByProfCategory}" disabled nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of limitAgesByProfCategory" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="retirementLimitAgeCode"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4" *ngIf="isWorkflowAgeLimit">
      <div class="form-group">
        <label for="RetirementLimitDate" class="disabled">
          {{'CardCgaPensionStatus.RetirementLimitDate' | translate}}
          <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardCgaPensionStatus.RetirementLimitDate' | translate}}"></span>
        </label>

        <div class="input-group">
          <input #dpRetirementLimitDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}" maxlength="10"
                 [(ngModel)]="cardData.retirementLimitDate" name="retirementLimitDate" #retirementLimitDate="ngModel" disabled
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" >
          <div class="input-group-append disable-on-fieldset" (click)="!dpRetirementLimitDate.isDisabled && dpRetirementLimitDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="retirementLimitDate"></validation-message>
        </div>
      </div>
    </div>
  </div>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->
